/**
 * TodoScrollContext - Provides scroll-to-input and editing state so inline
 * editors can keep themselves visible above the keyboard and signal the
 * parent to hide overlapping UI (e.g. the quick-add bar).
 */

import { createContext, useContext } from 'react';
import type { View } from 'react-native';

type ScrollToInputFn = (viewRef: React.RefObject<View | null>) => void;
type ScrollToCardFn = (viewRef: React.RefObject<View | null>) => void;
type SetEditingFn = (editing: boolean) => void;

interface TodoScrollContextValue {
  scrollToInput: ScrollToInputFn;
  scrollToCard: ScrollToCardFn;
  setIsEditing: SetEditingFn;
}

const TodoScrollContext = createContext<TodoScrollContextValue>({
  scrollToInput: () => {},
  scrollToCard: () => {},
  setIsEditing: () => {},
});

export const TodoScrollProvider = TodoScrollContext.Provider;

export function useTodoScroll(): TodoScrollContextValue {
  return useContext(TodoScrollContext);
}
